export const container = `
  flex flex-col gap-2 text-left max-h-0 overflow-hidden pl-4

  group-data-[is-active="true"]/categories-toggle-score:max-h-full
  group-data-[is-active="true"]/categories-toggle-score:mt-2
`;
